(function () {
	"use strict";

	/*
	 * utility function to convert time strings, "00:03:18" (h:m:s) to number of seconds
	 */
	String.prototype.toSeconds = function () {
		if (this.match(/\d{1,2}:\d{2}:\d{2}/)) {
			var t = this.split(":"),
				h = parseInt(t[0], 10),
				m = parseInt(t[1], 10),
				s = parseInt(t[2], 10);
			return ((h*3600) + (m*60) + s);
		} else {
			return NaN;
		}
	};

	/*
	 * function to react to clicks on chapter links
	 */
	function seekToChapter(event) {
		var time = event.currentTarget.href.split("#").pop();
		video.pause();
		video.currentTime = time.toSeconds();
		video.play();
		event.preventDefault();
	}

	/*
	 * only proceed if the browser supports html 5 video
	 */
	var video = document.getElementsByTagName("video").item(0);

	if ("currentTime" in video) {
		var chapters = document.getElementById("chapters");
		var chapterLinks = chapters.getElementsByTagName("a");

		for(var i=0,l=chapterLinks.length; i<l; i+=1) {
			var link = chapterLinks.item(i);
			if (link.addEventListener) {
				link.addEventListener("click", seekToChapter, false);
			} else {
				link.attachEvent("onclick", seekToChapter);
			}
		}
	}

})();
